import { css } from '@emotion/react'
import styled from '@emotion/styled'

const headerStyles = ({ theme }) => css`
  label: header;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  padding-top: ${theme.spacings.mega};

  ${theme.media.giga} {
    flex-direction: row;
    padding-top: ${theme.spacings.kilo};
  }
`

const textBalanceStyles = ({ theme }) => css`
  label: text--balance;

  position: relative;

  display: block;

  color: ${theme.colors.n600};
  font-size: ${theme.typography.text.kilo.fontSize};
  text-align: right;

  ${theme.media.mega} {
    font-size: ${theme.typography.text.mega.fontSize};
  }

  ${theme.media.giga} {
    margin: -${theme.spacings.kilo} ${theme.spacings.tera} ${theme.spacings.tera} 0;

    font-size: ${theme.typography.headings.tera.fontSize};
  }
`

const ticketStyles = ({ theme }) => css`
  label: ticket;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  white-space: pre-wrap;

  ${theme.media.giga} {
    width: 245px;
    height: 60px;

    border: 1px solid ${theme.colors.n400};
    border-radius: 24px;

    &:before,
    &:after {
      content: '';

      position: absolute;
      top: 50%;

      width: 22px;
      height: 22px;

      background: ${theme.colors.white};

      transform: translateY(-50%);
    }

    &:before {
      left: -11px;

      border: 1px solid ${theme.colors.n400};
      border-radius: ${theme.borderRadius.circle};
    }

    &:after {
      left: -23px;
    }
  }
`

const ticketBoxStyles = () => css`
  label: ticket__box;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const ticketValueStyles = ({ theme }) => css`
  label: ticket__value;

  display: inline-block;
  color: ${theme.colors.white};

  font-size: ${theme.typography.headings.tera.fontSize};
  font-weight: ${theme.font.weight.semibold};

  background: linear-gradient(${theme.colors.f700}, ${theme.colors.v500});
  background-clip: text;
  -webkit-text-fill-color: transparent;

  ${theme.media.giga} {
    font-size: 28px;
  }
`

const textBonusStyles = ({ theme }) => css`
  label: text--bonus;

  display: flex;
  align-items: center;
  margin-top: ${theme.spacings.kilo};
  color: ${theme.colors.n600};
  font-size: 14px;

  svg {
    display: block;
    width: 14px;
    margin-right: 8px;
  }
`

const textExpirationStyles = ({ theme }) => css`
  label: text--expiration;

  display: block;
  margin-top: ${theme.spacings.kilo};

  color: ${theme.colors.n300};
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  font-style: italic;
  text-align: center;

  span {
    display: inline-block;
  }

  ${theme.media.giga} {
    text-align: right;
  }
`

export const Header = styled('header')(headerStyles)
export const TextBalance = styled('span')(textBalanceStyles)
export const Ticket = styled('div')(ticketStyles)
export const TicketBox = styled('div')(ticketBoxStyles)
export const TicketValue = styled('span')(ticketValueStyles)
export const TextBonus = styled('span')(textBonusStyles)
export const TextExpiration = styled('span')(textExpirationStyles)
